import React, { useEffect, useRef, useState, useContext } from "react";
import useDetectKeyboardOpen from "use-detect-keyboard-open";
import { ChatContext } from "../../contexts/ChatContext";
import { isMobileOrTablet } from "../Views/MobileClassRenderer";
import ChatMessage from "./ChatMessage";

export default function ChatMessageList({
  messageCollection,
  filter,
  type,
  tabIsOpen,
  mutedList,
  isCorporateAgent,
  hostRoomUrl,
}) {
  const bottomScrollRef = useRef(null);
  const messageListRef = useRef(null);
  const { toggleChat } = useContext(ChatContext);
  const isKeyboardOpen = useDetectKeyboardOpen();
  const [previousMessageCount, setPreviousMessageCount] = useState(0);

  useEffect(() => {
    if (
      tabIsOpen ||
      (isCorporateAgent &&
        messageCollection.messageList.length > previousMessageCount)
    ) {
      setPreviousMessageCount(messageCollection.messageList.length);
      handleScroll();
    }
  }, [
    messageListRef,
    bottomScrollRef,
    tabIsOpen,
    messageCollection,
    toggleChat,
  ]);

  useEffect(() => {
    handleScroll()
  }, [isKeyboardOpen,])

  const wait = (time) => new Promise((resolve) => setTimeout(() => resolve(), time))

  async function handleScroll() {
    const scroll = () => bottomScrollRef.current?.scrollIntoView({ behavior: 'instant', block: 'nearest', inline: 'nearest' })
    scroll()
    await wait(500)
    scroll()
  }

  // function userIsMuted() {
  //     const list = mutedList || {}
  //     const isMuted = Object.entries(list).some(event_user => {
  //         const [eventUserId, muted] = event_user

  //         return muted && messageCollection?.getMe()?.id == eventUserId
  //     })

  //     return isMuted
  // }

  return (
    <div className={`chat-message-list overflow-auto`} ref={messageListRef}>
      {messageCollection &&
        messageCollection.messageList.map((messageData, i) => {
          if (filter && messageData.isHighlighted) {
            return (
              <ChatMessage
                key={messageData._urlParams.firebaseID}
                messageData={messageData}
                type={type}
                mutedList={mutedList}
                me={messageCollection.me}
                isCorporateAgent={isCorporateAgent}
                hostRoomUrl={hostRoomUrl}
              />
            );
          } else if (!filter) {
            return (
              <ChatMessage
                key={messageData._urlParams.firebaseID}
                messageData={messageData}
                type={type}
                mutedList={mutedList}
                me={messageCollection.me}
                isCorporateAgent={isCorporateAgent}
                hostRoomUrl={hostRoomUrl}
              />
            );
          }
        })}
     <div style={{ height: "2px" }} ref={bottomScrollRef}></div>
     {/* {!isCorporateAgent && <div style={{ height: "2px" }} ref={bottomScrollRef}></div> } */}
    </div>
  );
}
